<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.product.export') }}
      </h1>

      <div class="card rounded-0 mb-4">
        <form class="card-body">
          <div class="row mb-2">
            <div class="col-16 col-sm-12 col-xl-4 justify-content-end me-auto ms-auto text-center">
              <label class="control-label fw-bold mb-3">
                {{ $t('label.product.exportFolder') }}
              </label>
              <br>
              <div
                v-if="isProcessing"
                class="text-center"
              >
                <img
                  src="@/assets/img/loader.gif"
                  class="mx-auto d-block center-block"
                >
              </div>
              <button
                v-else
                type="button"
                class="btn btn-primary rounded-pill font-custom font-inverted btn-export"
                @click="downloadExcelParam()"
              >
                <i class="far fa-file-excel me-1" />
                {{ $t('button.exportExcel') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <SuccessDialog ref="successDialogRef" />
    <ErrorDialog ref="errorDialogRef" />
  </div>
</template>

<script src="./ProductExport.js"></script>

<style src="./ProductExport.scss" scoped lang="scss"></style>
